var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashTitleIc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_62",
    "data-name": "Rectangle 62",
    width: 18,
    height: 18,
    transform: "translate(310 84)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_33",
    "data-name": "Mask Group 33",
    transform: "translate(-310 -84)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(310 84)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M4.817,6.517h-3.3a.751.751,0,0,0-.75.75v12a.751.751,0,0,0,.75.75h3.3a.751.751,0,0,0,.75-.75v-12a.751.751,0,0,0-.75-.75Zm-.45,12.3h-2.4V7.717h2.4Z",
    transform: "translate(-0.767 -2.017)",
    fill: "#089cbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M13.25,11.5H9.95a.751.751,0,0,0-.75.75v8.1a.751.751,0,0,0,.75.75h3.3a.751.751,0,0,0,.75-.75v-8.1a.751.751,0,0,0-.75-.75Zm-.45,8.4H10.4V12.7h2.4Z",
    transform: "translate(-2.6 -3.1)",
    fill: "#089cbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M21.683.767h-3.3a.751.751,0,0,0-.75.75v16.5a.751.751,0,0,0,.75.75h3.3a.751.751,0,0,0,.75-.75V1.517A.751.751,0,0,0,21.683.767Zm-.45,16.8h-2.4V1.967h2.4Z",
    transform: "translate(-4.433 -0.767)",
    fill: "#089cbc"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashTitleIc);
export default __webpack_public_path__ + "static/media/dashTitleIc.a283b5eb564a9401007d64110e09657d.svg";
export { ForwardRef as ReactComponent };